function stillImage(item) {
  if (!item?.contentUrl && !item?.output?.contentUrl) return false;
  const mime = item.mimeType || item.output?.mimeType || '';
  const file = item.path || item.output?.path || '';
  if (mime === 'video/mp4' || String(file).endsWith('.mp4')) return false;
  return true;
}

function preferStill(items) {
  const standing = items.find((item) => /standing|full body|full-body/i.test(item.pose || ''));
  const head = items.find((item) => /\bhead\b/i.test(item.pose || ''));
  return standing || head || items[0] || null;
}

export function shelfLock(card) {
  const images = (card?.locks || []).filter(stillImage);
  return preferStill(images);
}

export function shelfPicture(card) {
  return shelfLock(card)?.contentUrl || '';
}

export function shelfStoragePath(seriesId, card) {
  const lock = shelfLock(card);
  if (!seriesId || !lock?.path) return '';
  return `series/${seriesId}/${lock.path}`;
}

export function generationPortrait(character, generations) {
  const stills = (generations || []).filter((generation) => {
    if (generation.characterId !== character?.id) return false;
    if (generation.pageId || generation.error) return false;
    if (!generation.lockedAsReference && !generation.approved) return false;
    return stillImage(generation);
  });
  return preferStill(stills)?.output?.contentUrl || '';
}

export function shelfDisplayName(name) {
  const text = String(name || '').trim();
  const cut = text.split(':')[0].trim();
  return cut || text;
}

export function isShelfPerson(character) {
  const kind = String(character?.meta?.kind || '').toLowerCase();
  return kind === 'person' || kind === 'dog';
}
